
import { Component, State, Vue } from 'nuxt-property-decorator';
import ReadAloud from './library/ReadAloud.vue';
import ReadAloudStore from './library/read-aloud.store';
import { registerInterceptor } from './library/PollyInterceptor';
import {
  DefaultVoiceSelection,
  Gender,
  Language,
  VoiceSelection
} from './library/models';
import { Site } from '@/types/initialData';

@Component({
  components: { ReadAloud }
})
export default class IBKNGReadAloud extends Vue {
  // @ts-ignore
  @State((state) => state.typo3?.initial?.site) // notice : there's also id, and that reflects the query param
  site: Site;

  get isPlayerShowing(): boolean {
    return ReadAloudStore.playerShowing;
  }

  mounted() {
    this.registerInterceptionWhenPollyLoaded();
    this.setDefaultLanguageWhenLoaded();
  }

  async registerInterceptionWhenPollyLoaded() {
    if (!window.gPolly || !this.site) {
      await setTimeout(this.registerInterceptionWhenPollyLoaded, 200);
    } else {
      registerInterceptor(this.site);
    }
  }

  async setDefaultLanguageWhenLoaded() {
    if (!this.site) {
      await setTimeout(this.setDefaultLanguageWhenLoaded, 200);
    } else {
      this.setDefaultLanguage();
    }
  }

  private setDefaultLanguage() {
    const isoCode = this.$i18n.locale ?? 'en';
    const voice = this.getVoiceForIsoCode(isoCode);

    if (!ReadAloudStore.defaultVoiceSettingsChanged) {
      ReadAloudStore.voice = voice;
    }

    /*
    console.log(
      `Set default read aloud voice to be: ${this.getCurrentLanguage(
        voice.language
      )}, ${this.getCurrentGender(voice.gender)}`
    );
    */
  }

  getCurrentGender(gender: Gender): string {
    switch (gender) {
      case Gender.Male:
        return this.$tc('labels.polly.gender.male');
      case Gender.Female:
        return this.$tc('labels.polly.gender.female');
      default:
        return 'Gender not in list';
    }
  }

  getCurrentLanguage(language: Language): string {
    switch (language) {
      case Language.Danish:
        return this.$tc('labels.polly.languages.da');
      case Language.French:
        return this.$tc('labels.polly.languages.fr');
      case Language.German:
        return this.$tc('labels.polly.languages.de');
      case Language.Spanish:
        return this.$tc('labels.polly.languages.es');
      case Language.English:
        return this.$tc('labels.polly.languages.en');
      case Language.Icelandic:
        return this.$tc('labels.polly.languages.is');
      case Language.Swedish:
        return this.$tc('labels.polly.languages.se');
      default:
        return 'Language not in list';
    }
  }

  private getVoiceForIsoCode(isoCode: string): VoiceSelection {
    switch (isoCode) {
      case 'da':
        return {
          voice: 1,
          gender: Gender.Female,
          language: Language.Danish
        };
      case 'en':
        return {
          voice: 3,
          gender: Gender.Female,
          language: Language.English
        };
      case 'fr':
        return {
          voice: 5,
          gender: Gender.Female,
          language: Language.French
        };
      case 'de':
        return {
          voice: 7,
          gender: Gender.Female,
          language: Language.German
        };
      case 'es':
        return {
          voice: 9,
          gender: Gender.Female,
          language: Language.Spanish
        };
      case 'is':
        return {
          voice: 12,
          gender: Gender.Female,
          language: Language.Icelandic
        };
      case 'se':
        return {
          voice: 13,
          gender: Gender.Female,
          language: Language.Swedish
        };
      default:
        return DefaultVoiceSelection;
    }
  }
}
